// apps/web/src/views/app-views/roulette/prizes/index.js

import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Statistic,
  Switch,
  Table,
  Tabs,
  Tag,
  Typography,
  Upload,
  message,
} from 'antd'
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  DeleteOutlined,
  EditOutlined,
  HistoryOutlined,
  InboxOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  ReloadOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import { useEffect, useMemo, useState } from 'react'
import { api } from 'services/api'
import UploadService from 'services/UploadService'

const { Title, Text } = Typography

const API_BASE_URL = 'https://games.nlbsolucoes.com/api'

const defaultColors = [
  '#ffffff',
  '#ffd84a',
  '#0b73b7',
  '#d9363e',
  '#80c6a0',
  '#59bed1',
  '#aa92df',
  '#086faf',
]

const getImageUrl = (url) => {
  if (!url) return null
  if (url.startsWith('http')) return url
  return `${API_BASE_URL}${url}`
}

const isLightColor = (color) => {
  if (!color || !color.startsWith('#')) return false

  const hex = color.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return r * 0.299 + g * 0.587 + b * 0.114 > 175
}

const PrizesPage = () => {
  const [games, setGames] = useState([])
  const [gameId, setGameId] = useState()
  const [prizes, setPrizes] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [editingPrize, setEditingPrize] = useState(null)
  const [uploading, setUploading] = useState(false)

const [stockModalOpen, setStockModalOpen] = useState(false)
const [selectedPrizeStock, setSelectedPrizeStock] = useState(null)
const [stockLoading, setStockLoading] = useState(false)
const [stockSubmitting, setStockSubmitting] = useState(false)
const [stockMovements, setStockMovements] = useState([])
const [stockAction, setStockAction] = useState('entry')

const [form] = Form.useForm()
const [stockForm] = Form.useForm()

  const selectedGame = useMemo(() => {
    return games.find((item) => item.id === gameId)
  }, [games, gameId])

  const loadGames = async () => {
    try {
      const response = await api.get('/games')
      const data = response?.data || response
      const list = Array.isArray(data) ? data : []

      setGames(list)

      if (list.length && !gameId) {
        setGameId(list[0].id)
      }
    } catch (error) {
      message.error('Erro ao carregar jogos')
    }
  }

  const loadPrizes = async (selectedGameId) => {
    if (!selectedGameId) {
      setPrizes([])
      return
    }

    setLoading(true)

    try {
      const response = await api.get(`/prizes?gameId=${selectedGameId}`)
      const data = response?.data || response
      const list = Array.isArray(data) ? data : []

      setPrizes(
        list
          .slice()
          .sort((a, b) => Number(a.position || 0) - Number(b.position || 0)),
      )
    } catch (error) {
      message.error('Erro ao carregar brindes')
    } finally {
      setLoading(false)
    }
  }

  const uploadPrizeImage = async ({
  file,
  onSuccess,
  onError,
}) => {
  try {
    setUploading(true)

    const response = await UploadService.image(file)
    const data = response?.data || response

    if (!data?.url) {
      throw new Error('A API não retornou a URL da imagem')
    }

    form.setFieldsValue({
      imageUrl: data.url,
    })

    message.success('Imagem enviada com sucesso')

    if (typeof onSuccess === 'function') {
      onSuccess(data)
    }
  } catch (error) {
    console.error('ERRO NO UPLOAD DO BRINDE:', error)

    message.error(
      error?.response?.data?.message ||
        error?.message ||
        'Erro ao enviar imagem do prêmio',
    )

    if (typeof onError === 'function') {
      onError(error)
    }
  } finally {
    setUploading(false)
  }
}

  const openCreate = () => {
    setEditingPrize(null)
    form.resetFields()

    form.setFieldsValue({
      color: defaultColors[prizes.length % defaultColors.length],
      stockInitial: 10,
      stockAvailable: 10,
      probabilityWeight: 1,
      position: prizes.length + 1,
      isActive: true,
      redirectEnabled: false,
      redirectUrl: null,
      redirectDelay: 1500,
    })

    setModalOpen(true)
    
  }

  const openEdit = (record) => {
    setEditingPrize(record)

    form.setFieldsValue({
      name: record.name,
      description: record.description,
      imageUrl: record.imageUrl,
      color: record.color || '#1677ff',
      stockInitial: record.stockInitial || 0,
      stockAvailable: record.stockAvailable || 0,
      probabilityWeight: record.probabilityWeight || 1,
      position: record.position || 0,
      isActive: record.isActive ?? true,
      redirectEnabled: record.redirectEnabled ?? false,
      redirectUrl: record.redirectUrl || null,
      redirectDelay: record.redirectDelay || 1500,
    })

    setModalOpen(true)
  }

  const handleSubmit = async (values) => {
    if (!gameId) {
      message.error('Selecione um jogo')
      return
    }

    try {
      const payload = {
        gameId,
        name: values.name,
        description: values.description || null,
        imageUrl: values.imageUrl || null,
        color: values.color || '#1677ff',
        stockInitial: Number(values.stockInitial || 0),
        stockAvailable:
          values.stockAvailable !== undefined
            ? Number(values.stockAvailable || 0)
            : Number(values.stockInitial || 0),
        probabilityWeight: Number(values.probabilityWeight || 1),
        position: Number(values.position || 0),
        isActive: values.isActive ?? true,
        redirectEnabled: values.redirectEnabled ?? false,
        redirectUrl: values.redirectUrl || null,
        redirectDelay: Number(values.redirectDelay || 1500),
      }

      if (editingPrize) {
        await api.patch(`/prizes/${editingPrize.id}`, payload)
        message.success('Brinde atualizado')
      } else {
        await api.post('/prizes', payload)
        message.success('Brinde criado')
      }

      setModalOpen(false)
      setEditingPrize(null)
      form.resetFields()
      loadPrizes(gameId)
    } catch (error) {
      message.error(error?.response?.data?.message || 'Erro ao salvar brinde')
    }
  }

  const handleDelete = async (id) => {
    try {
      await api.delete(`/prizes/${id}`)
      message.success('Brinde removido')
      loadPrizes(gameId)
    } catch (error) {
      message.error('Erro ao remover brinde')
    }
  }

  const loadPrizeMovements = async (prizeId) => {
  if (!prizeId) {
    setStockMovements([])
    return
  }

  setStockLoading(true)

  try {
    const response = await api.get(
      `/prizes/${prizeId}/movements?page=1&limit=100`,
    )

    const data = response?.data || response

    const items = Array.isArray(data)
      ? data
      : Array.isArray(data?.items)
        ? data.items
        : []

    setStockMovements(items)
  } catch (error) {
    console.error('ERRO AO CARREGAR MOVIMENTAÇÕES:', error)

    message.error(
      error?.response?.data?.message ||
        'Erro ao carregar movimentações de estoque',
    )

    setStockMovements([])
  } finally {
    setStockLoading(false)
  }
}

const openStockModal = async (record) => {
  setSelectedPrizeStock(record)
  setStockAction('entry')
  setStockMovements([])

  stockForm.resetFields()

  stockForm.setFieldsValue({
    action: 'entry',
    quantity: 1,
    countedStock: record.stockAvailable || 0,
    notes: null,
  })

  setStockModalOpen(true)

  await loadPrizeMovements(record.id)
}

const closeStockModal = () => {
  setStockModalOpen(false)
  setSelectedPrizeStock(null)
  setStockMovements([])
  setStockAction('entry')
  stockForm.resetFields()
}

const handleStockActionChange = (event) => {
  const action = event.target.value

  setStockAction(action)

  stockForm.setFieldsValue({
    action,
    quantity: 1,
    countedStock:
      selectedPrizeStock?.stockAvailable || 0,
    notes: null,
  })
}

const handleStockSubmit = async (values) => {
  if (!selectedPrizeStock?.id) {
    message.error('Nenhum brinde selecionado')
    return
  }

  setStockSubmitting(true)

  try {
    const action = values.action || stockAction

    if (action === 'entry') {
      await api.post(
        `/prizes/${selectedPrizeStock.id}/stock/entry`,
        {
          quantity: Number(values.quantity || 0),
          notes: values.notes || null,
        },
      )

      message.success('Entrada de estoque registrada')
    }

    if (action === 'exit') {
      await api.post(
        `/prizes/${selectedPrizeStock.id}/stock/exit`,
        {
          quantity: Number(values.quantity || 0),
          notes: values.notes || null,
        },
      )

      message.success('Saída de estoque registrada')
    }

    if (action === 'return') {
      await api.post(
        `/prizes/${selectedPrizeStock.id}/stock/return`,
        {
          quantity: Number(values.quantity || 0),
          notes: values.notes || null,
        },
      )

      message.success('Retorno de estoque registrado')
    }

    if (action === 'adjust') {
      await api.post(
        `/prizes/${selectedPrizeStock.id}/stock/adjust`,
        {
          stockAvailable: Number(
            values.countedStock || 0,
          ),
          notes: values.notes || null,
        },
      )

      message.success('Estoque ajustado')
    }

    await loadPrizes(gameId)
    await loadPrizeMovements(selectedPrizeStock.id)

    const refreshedResponse = await api.get(
      `/prizes/${selectedPrizeStock.id}`,
    )

    const refreshedPrize =
      refreshedResponse?.data || refreshedResponse

    setSelectedPrizeStock(refreshedPrize)

    stockForm.setFieldsValue({
      quantity: 1,
      countedStock:
        refreshedPrize.stockAvailable || 0,
      notes: null,
    })
  } catch (error) {
    console.error('ERRO AO MOVIMENTAR ESTOQUE:', error)

    message.error(
      error?.response?.data?.message ||
        'Erro ao movimentar estoque',
    )
  } finally {
    setStockSubmitting(false)
  }
}

const getMovementTypeLabel = (type) => {
  const labels = {
    INITIAL: 'Estoque inicial',
    ENTRY: 'Entrada',
    EXIT: 'Saída',
    DELIVERY: 'Entrega',
    RETURN: 'Retorno',
    ADJUSTMENT: 'Ajuste',
  }

  return labels[type] || type
}

const getMovementTypeColor = (type) => {
  const colors = {
    INITIAL: 'blue',
    ENTRY: 'green',
    EXIT: 'volcano',
    DELIVERY: 'purple',
    RETURN: 'cyan',
    ADJUSTMENT: 'gold',
  }

  return colors[type] || 'default'
}

const formatDateTime = (value) => {
  if (!value) return '-'

  return new Date(value).toLocaleString('pt-BR')
}

  const movePrize = async (record, direction) => {
    const ordered = prizes
      .slice()
      .sort((a, b) => Number(a.position || 0) - Number(b.position || 0))

    const currentIndex = ordered.findIndex((item) => item.id === record.id)
    const targetIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1

    if (targetIndex < 0 || targetIndex >= ordered.length) return

    const current = ordered[currentIndex]
    const target = ordered[targetIndex]

    try {
      await Promise.all([
        api.patch(`/prizes/${current.id}`, {
          gameId,
          position: target.position,
        }),
        api.patch(`/prizes/${target.id}`, {
          gameId,
          position: current.position,
        }),
      ])

      loadPrizes(gameId)
    } catch (error) {
      message.error('Erro ao reordenar brinde')
    }
  }

  useEffect(() => {
    loadGames()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    loadPrizes(gameId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameId])

  const wheelBackground = useMemo(() => {
    if (!prizes.length) return '#ddd'

    const size = 360 / prizes.length

    return `conic-gradient(${prizes
      .map((prize, index) => {
        const start = index * size
        const end = start + size
        const color =
          prize.color ||
          prize.backgroundColor ||
          defaultColors[index % defaultColors.length]

        return `${color} ${start}deg ${end}deg`
      })
      .join(',')})`
  }, [prizes])

  const columns = [
    {
      title: '#',
      width: 60,
      render: (_, record) => (
        <InputNumber
          size="small"
          min={0}
          value={record.position}
          style={{ width: 52 }}
          disabled
        />
      ),
    },
    {
      title: 'Imagem',
      dataIndex: 'imageUrl',
      width: 130,
      render: (imageUrl) =>
        imageUrl ? (
          <div
            style={{
              width: 96,
              height: 54,
              borderRadius: 8,
              background: '#f5f5f5',
              border: '1px solid #e5e7eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <Image
              src={getImageUrl(imageUrl)}
              preview={false}
              style={{
                maxWidth: 88,
                maxHeight: 46,
                objectFit: 'contain',
              }}
            />
          </div>
        ) : (
          <Tag>Texto</Tag>
        ),
    },
    {
      title: 'Nome do prêmio',
      dataIndex: 'name',
      render: (value) => <Input value={value} disabled />,
    },
    {
      title: 'Cor do segmento',
      dataIndex: 'color',
      width: 170,
      render: (color) => (
        <Space>
          <div
            style={{
              width: 22,
              height: 22,
              borderRadius: 4,
              background: color,
              border: '1px solid #ddd',
            }}
          />
          <Text code>{color}</Text>
        </Space>
      ),
    },
    {
      title: 'Estoque',
      width: 110,
      render: (_, record) => (
        <Tag color={record.stockAvailable > 0 ? 'green' : 'red'}>
          {record.stockAvailable}/{record.stockInitial}
        </Tag>
      ),
    },
    {
  title: 'Ações',
  width: 280,
  fixed: 'right',
  render: (_, record) => (
    <Space wrap>
      <Button
        size="small"
        icon={<ArrowUpOutlined />}
        onClick={() => movePrize(record, 'up')}
      />

      <Button
        size="small"
        icon={<ArrowDownOutlined />}
        onClick={() => movePrize(record, 'down')}
      />

      <Button
        size="small"
        type="primary"
        ghost
        icon={<InboxOutlined />}
        onClick={() => openStockModal(record)}
      >
        Estoque
      </Button>

      <Button
        size="small"
        icon={<EditOutlined />}
        onClick={() => openEdit(record)}
      />

      <Popconfirm
        title="Remover brinde?"
        okText="Sim"
        cancelText="Não"
        onConfirm={() =>
          handleDelete(record.id)
        }
      >
        <Button
          size="small"
          danger
          icon={<DeleteOutlined />}
        />
      </Popconfirm>
    </Space>
  ),
},
  ]

  return (
    <>
      <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <Title level={2} style={{ margin: 0 }}>
            Prêmios da Roleta
          </Title>
          <p>Configure os prêmios que aparecerão na roleta e a ordem de exibição.</p>
        </div>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          disabled={!gameId}
          onClick={openCreate}
        >
          Adicionar prêmio
        </Button>
      </Space>

      <Card style={{ marginBottom: 16 }}>
        <Select
          style={{ width: 520, maxWidth: '100%' }}
          placeholder="Selecione o jogo"
          value={gameId}
          onChange={setGameId}
          showSearch
          optionFilterProp="children"
        >
          {games.map((game) => (
            <Select.Option key={game.id} value={game.id}>
              {game.name}
              {game.event?.name ? ` - ${game.event.name}` : ''}
            </Select.Option>
          ))}
        </Select>
      </Card>

      <Row gutter={16}>
        <Col xs={24} lg={14}>
          <Card
            title="Prêmios"
            extra={
              <Text type="secondary">
                {selectedGame?.name || 'Nenhum jogo selecionado'}
              </Text>
            }
          >
            <Table
              rowKey="id"
              loading={loading}
              dataSource={prizes}
              columns={columns}
              pagination={false}
              scroll={{ x: 900 }}
            />

            <Alert
              style={{ marginTop: 16 }}
              type="info"
              showIcon
              message="Dica: use os botões de seta para reordenar os prêmios na roleta."
            />
          </Card>
        </Col>

        <Col xs={24} lg={10}>
          <Card title="Preview da Roleta">
            <p style={{ marginTop: -8, color: '#6b7280' }}>
              Visualização de como a roleta será exibida para o participante.
            </p>

            <div className="admin-wheel-preview-wrap">
              <div className="admin-wheel-lights">
                {Array.from({ length: 28 }).map((_, index) => (
                  <span
                    key={index}
                    className="admin-wheel-light"
                    style={{
                      transform: `rotate(${(360 / 28) * index}deg) translateY(-184px)`,
                    }}
                  />
                ))}
              </div>

              <div className="admin-wheel-pointer" />

              <div className="admin-wheel" style={{ background: wheelBackground }}>
                {prizes.map((prize, index) => {
                  const angle = (360 / prizes.length) * index + 360 / prizes.length / 2
                  const color =
                    prize.color ||
                    prize.backgroundColor ||
                    defaultColors[index % defaultColors.length]
                  const textDark = isLightColor(color)

                  return (
                    <div
                      key={prize.id || index}
                      className="admin-wheel-item"
                      style={{
                        transform: `rotate(${angle}deg) translateY(-112px) rotate(90deg)`,
                      }}
                    >
                      {prize.imageUrl ? (
                        <img
                          src={getImageUrl(prize.imageUrl)}
                          alt={prize.name}
                          className="admin-wheel-prize-img"
                        />
                      ) : (
                        <div className={`admin-wheel-prize-text ${textDark ? 'dark' : ''}`}>
                          {prize.name}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>

              <div className="admin-wheel-center">GIRAR</div>
            </div>

            <Alert
              style={{ marginTop: 20 }}
              type="info"
              showIcon
              message="Use imagens PNG transparentes e quadradas. Recomendado: 512x512px."
            />
          </Card>
        </Col>
      </Row>

      <Modal
        title={editingPrize ? 'Editar Prêmio' : 'Novo Prêmio'}
        visible={modalOpen}
        onCancel={() => {
          setModalOpen(false)
          setEditingPrize(null)
          form.resetFields()
        }}
        onOk={() => form.submit()}
        okText="Salvar"
        cancelText="Cancelar"
        destroyOnClose
        width={720}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col xs={24} md={14}>
              <Form.Item
                name="name"
                label="Nome do prêmio"
                rules={[{ required: true, message: 'Informe o nome do prêmio' }]}
              >
                <Input placeholder="Ex: Copo personalizado" />
              </Form.Item>

              <Form.Item name="description" label="Descrição">
                <Input.TextArea placeholder="Descrição opcional" />
              </Form.Item>

              <Form.Item
  name="imageUrl"
  label="Imagem do prêmio"
>
  <Input
    placeholder="URL da imagem ou utilize o upload abaixo"
    onChange={() => {
      form.validateFields(['imageUrl']).catch(() => {})
    }}
  />
</Form.Item>

              <Upload
                customRequest={uploadPrizeImage}
                showUploadList={false}
                accept=".png,.jpg,.jpeg,.webp"
              >
                <Button
                  icon={<UploadOutlined />}
                  loading={uploading}
                  style={{ marginBottom: 16 }}
                >
                  Enviar imagem do prêmio
                </Button>
              </Upload>

              <Form.Item name="color" label="Cor do segmento">
                <Input type="color" />
              </Form.Item>
            </Col>

            <Col xs={24} md={10}>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  const imageUrl = getFieldValue('imageUrl')
                  const color = getFieldValue('color') || '#1677ff'
                  const name = getFieldValue('name') || 'Prêmio'

                  return (
                    <div
                      style={{
                        minHeight: 240,
                        borderRadius: 18,
                        background: color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 20,
                        marginBottom: 16,
                        textAlign: 'center',
                      }}
                    >
                      {imageUrl ? (
                        <img
                          src={getImageUrl(imageUrl)}
                          alt={name}
                          style={{
                            maxWidth: 180,
                            maxHeight: 160,
                            objectFit: 'contain',
                            filter: 'drop-shadow(0 8px 10px rgba(0,0,0,.25))',
                          }}
                        />
                      ) : (
                        <strong
                          style={{
                            color: isLightColor(color) ? '#111' : '#fff',
                            fontSize: 24,
                            textTransform: 'uppercase',
                            lineHeight: 1.1,
                          }}
                        >
                          {name}
                        </strong>
                      )}
                    </div>
                  )
                }}
              </Form.Item>

              <Form.Item name="isActive" label="Ativo" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                name="stockInitial"
                label="Estoque inicial"
                rules={[{ required: true, message: 'Informe o estoque inicial' }]}
              >
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item name="stockAvailable" label="Estoque disponível">
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="probabilityWeight"
                label="Peso de probabilidade"
                rules={[{ required: true, message: 'Informe o peso' }]}
              >
                <InputNumber min={1} style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item name="position" label="Posição na roleta">
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Card size="small" title="Página personalizada do prêmio" style={{ marginTop: 16 }}>
  <Row gutter={16}>
    <Col xs={24}>
      <Form.Item
        name="redirectEnabled"
        label="Redirecionar após ganhar este prêmio?"
        valuePropName="checked"
      >
        <Switch />
      </Form.Item>
    </Col>

    <Col xs={24}>
      <Form.Item
        name="redirectUrl"
        label="URL da página personalizada"
        tooltip="Ex: https://site.com/premio ou /premios/brinde"
      >
        <Input placeholder="https://..." />
      </Form.Item>
    </Col>

    <Col xs={24} md={12}>
      <Form.Item name="redirectDelay" label="Tempo antes de redirecionar (ms)">
        <InputNumber min={0} step={500} style={{ width: '100%' }} />
      </Form.Item>
    </Col>
  </Row>
</Card>
        </Form>
      </Modal>
                <Modal
  title={
    selectedPrizeStock
      ? `Estoque — ${selectedPrizeStock.name}`
      : 'Estoque do brinde'
  }
  visible={stockModalOpen}
  onCancel={closeStockModal}
  footer={null}
  destroyOnClose
  width={920}
>
  <Row gutter={[16, 16]}>
    <Col xs={24} md={8}>
      <Card size="small">
        <Statistic
          title="Estoque disponível"
          value={
            selectedPrizeStock?.stockAvailable ||
            0
          }
          suffix={
            selectedPrizeStock?.stockInitial !==
            undefined
              ? `/ ${selectedPrizeStock.stockInitial}`
              : undefined
          }
        />
      </Card>
    </Col>

    <Col xs={24} md={8}>
      <Card size="small">
        <Statistic
          title="Estoque inicial"
          value={
            selectedPrizeStock?.stockInitial ||
            0
          }
        />
      </Card>
    </Col>

    <Col xs={24} md={8}>
      <Card size="small">
        <Statistic
          title="Movimentações"
          value={stockMovements.length}
        />
      </Card>
    </Col>
  </Row>

  <Tabs
    defaultActiveKey="movement"
    style={{ marginTop: 18 }}
  >
    <Tabs.TabPane
      tab={
        <span>
          <InboxOutlined />
          Movimentar estoque
        </span>
      }
      key="movement"
    >
      <Form
        layout="vertical"
        form={stockForm}
        onFinish={handleStockSubmit}
      >
        <Form.Item
          name="action"
          label="Tipo de movimentação"
          rules={[
            {
              required: true,
              message:
                'Selecione o tipo de movimentação',
            },
          ]}
        >
          <Radio.Group
            onChange={
              handleStockActionChange
            }
          >
            <Space wrap>
              <Radio.Button value="entry">
                <PlusCircleOutlined /> Entrada
              </Radio.Button>

              <Radio.Button value="exit">
                <MinusCircleOutlined /> Saída
              </Radio.Button>

              <Radio.Button value="return">
                <ReloadOutlined /> Retorno
              </Radio.Button>

              <Radio.Button value="adjust">
                <HistoryOutlined /> Ajuste
              </Radio.Button>
            </Space>
          </Radio.Group>
        </Form.Item>

        {stockAction !== 'adjust' ? (
          <Form.Item
            name="quantity"
            label="Quantidade"
            rules={[
              {
                required: true,
                message:
                  'Informe a quantidade',
              },
              {
                type: 'number',
                min: 1,
                message:
                  'A quantidade deve ser maior que zero',
              },
            ]}
          >
            <InputNumber
              min={1}
              precision={0}
              style={{ width: '100%' }}
            />
          </Form.Item>
        ) : (
          <Form.Item
            name="countedStock"
            label="Novo estoque disponível"
            extra="Informe a quantidade real atualmente disponível."
            rules={[
              {
                required: true,
                message:
                  'Informe o novo estoque disponível',
              },
              {
                type: 'number',
                min: 0,
                message:
                  'O estoque não pode ser negativo',
              },
            ]}
          >
            <InputNumber
              min={0}
              precision={0}
              style={{ width: '100%' }}
            />
          </Form.Item>
        )}

        <Form.Item
          name="notes"
          label="Observação"
        >
          <Input.TextArea
            rows={3}
            placeholder="Descreva o motivo da movimentação"
          />
        </Form.Item>

        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={stockSubmitting}
          >
            Registrar movimentação
          </Button>

          <Button
            onClick={closeStockModal}
          >
            Fechar
          </Button>
        </Space>
      </Form>
    </Tabs.TabPane>

    <Tabs.TabPane
      tab={
        <span>
          <HistoryOutlined />
          Histórico
        </span>
      }
      key="history"
    >
      <Table
        rowKey="id"
        loading={stockLoading}
        dataSource={stockMovements}
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
        }}
        scroll={{ x: 760 }}
        columns={[
          {
            title: 'Data',
            dataIndex: 'createdAt',
            width: 170,
            render: formatDateTime,
          },
          {
            title: 'Tipo',
            dataIndex: 'type',
            width: 130,
            render: (type) => (
              <Tag
                color={
                  getMovementTypeColor(type)
                }
              >
                {getMovementTypeLabel(type)}
              </Tag>
            ),
          },
          {
            title: 'Quantidade',
            dataIndex: 'quantity',
            width: 110,
          },
          {
            title: 'Antes',
            dataIndex: 'stockBefore',
            width: 90,
          },
          {
            title: 'Depois',
            dataIndex: 'stockAfter',
            width: 90,
          },
          {
            title: 'Observação',
            dataIndex: 'notes',
            render: (value) =>
              value || '-',
          },
          {
            title: 'Responsável',
            width: 170,
            render: (_, movement) =>
              movement.user?.name ||
              movement.user?.email ||
              'Sistema',
          },
        ]}
      />
    </Tabs.TabPane>
  </Tabs>
</Modal>
      <style>
        {`
          .admin-wheel-preview-wrap {
            width: 390px;
            height: 390px;
            max-width: 100%;
            margin: 28px auto 10px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .admin-wheel-lights {
            position: absolute;
            inset: 0;
            border-radius: 50%;
            background: #4c1393;
            box-shadow: 0 0 28px rgba(160, 75, 255, .65);
            border: 6px solid rgba(167, 86, 255, .65);
          }

          .admin-wheel-light {
            width: 9px;
            height: 9px;
            background: #fff7d6;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            top: 50%;
            box-shadow: 0 0 10px #ffb85c;
          }

          .admin-wheel-pointer {
            position: absolute;
            top: -4px;
            left: 50%;
            width: 34px;
            height: 56px;
            transform: translateX(-50%);
            z-index: 20;
            background: linear-gradient(180deg, #ffb14b, #ff681f);
            clip-path: polygon(50% 100%, 8% 42%, 18% 12%, 50% 0, 82% 12%, 92% 42%);
            box-shadow: 0 8px 18px rgba(0,0,0,.28);
          }

          .admin-wheel {
            width: 84%;
            height: 84%;
            border-radius: 50%;
            position: relative;
            overflow: hidden;
            border: 4px solid rgba(255,255,255,.6);
            box-shadow: inset 0 0 0 6px rgba(0,0,0,.14);
          }

          .admin-wheel-item {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 92px;
            height: 92px;
            margin-left: -46px;
            margin-top: -46px;
            transform-origin: 50% 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          }

          .admin-wheel-prize-img {
            max-width: 74px;
            max-height: 62px;
            object-fit: contain;
            filter: drop-shadow(0 6px 6px rgba(0,0,0,.22));
          }

          .admin-wheel-prize-text {
            width: 78px;
            font-size: 12px;
            line-height: 1.05;
            font-weight: 950;
            color: #fff;
            text-transform: uppercase;
            text-shadow: 0 2px 3px rgba(0,0,0,.28);
            word-break: normal;
            overflow-wrap: break-word;
          }

          .admin-wheel-prize-text.dark {
            color: #111;
            text-shadow: none;
          }

          .admin-wheel-center {
            width: 92px;
            height: 92px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            z-index: 18;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #6d28d9;
            font-weight: 950;
            font-size: 22px;
            box-shadow: 0 8px 16px rgba(0,0,0,.24);
          }
        `}
      </style>
    </>
  )
}

export default PrizesPage